import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../../structure/row';
import { Cell, LEFT, RIGHT } from '../../structure/cell';
import { FormattedPrice } from '../../../price/formatted_price';
import { Translation } from '../../../translation/translation';

export const ServiceFittingStationMainRow = ({
    fsTotalPrice,
    currencyIsoCode,
    fsDetailsVisible,
    fittingStationStreet,
    fittingStationSuburb,
    isMobileFitter,
    sidebarPostcode,
    onChangeStationClick,
    onRemoveStationClick,
    onShowFsDetailsClick,
}) => (
    <Row className="service-fitting-station" isMain={true}>
        <Cell colSpan={2} side={LEFT}>
            <div className="service-fitting-station__headline">
                <Translation
                    className="sidebar__row-headline"
                    translationKey="pdp-sidebar-service-fitting-station-headline"
                />

                <span style={{ marginLeft: '10px', cursor: 'pointer', verticalAlign: 'middle' }}>
                    <svg onClick={onRemoveStationClick} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                    </svg>
                </span>
            </div>

            {isMobileFitter &&
                <>
                    <Translation
                        tagName="div"
                        className="service-fitting-station__station-type"
                        translationKey="fitting-station-finder-app-mobile-fitter"
                    />
                    <span style={{ marginLeft: '5px' }}>
                        in {sidebarPostcode.substring(0, sidebarPostcode.lastIndexOf(','))}
                    </span>
                </>
            }

            <div className="service-fitting-station__station-address">
                {!isMobileFitter &&
                    fittingStationStreet + ', ' + fittingStationSuburb + ', ' + sidebarPostcode
                }
            </div>
        </Cell>
        <Cell colSpan={2} side={RIGHT}>
            {!fsDetailsVisible &&
                <FormattedPrice
                    price={fsTotalPrice}
                    currencyIsoCode={currencyIsoCode}
                    inCents={true}
                />
            }

            {!fsDetailsVisible &&
                <Translation
                    className="service-fitting-station__show-details"
                    translationKey="sidebar-fs-show-details"
                    onClick={onShowFsDetailsClick}
                />
            }

            {fsDetailsVisible &&
                <Translation
                    className="service-fitting-station__change"
                    onClick={onChangeStationClick}
                    translationKey="pdp-sidebar-service-fitting-station-change"
                />
            }
        </Cell>
    </Row>
);

ServiceFittingStationMainRow.propTypes = {
    fsTotalPrice: PropTypes.number.isRequired,
    fsDetailsVisible: PropTypes.bool.isRequired,
    fittingStationStreet: PropTypes.string.isRequired,
    fittingStationSuburb: PropTypes.string.isRequired,
    sidebarPostcode: PropTypes.string.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    onChangeStationClick: PropTypes.func.isRequired,
    onRemoveStationClick: PropTypes.func.isRequired,
    onShowFsDetailsClick: PropTypes.func.isRequired,
};
